import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import { getScreenWidth, isProduction } from "../../constants";

const LP = () => {
  const { isMobile, isTablet, isTwoColumn: isFlex, isDesktop } = getScreenWidth();

  const THEME_COLOR = "#ffc736";
  const HEADING_FONT = {
    fontFamily: "'Roboto Condensed', sans-serif",
    fontWeight: "bold",
    fontStyle: "italic",
  };
  const APP_NAME = <span style={{ color: THEME_COLOR }}>キントレマニア</span>;

  const styles = {
    container: {
      backgroundColor: "#141414",
      color: "#ffffff",
    },
    title: {
      backgroundColor: "#141414",
      display: "flex",
      alignItems: "center",
      padding: "10px",
      width: isMobile ? "200px" : isTablet ? "300px" : "400px",
    },
    titleImage: { width: isMobile ? 40 : isTablet ? 60 : 80, marginRight: "5px" },
    titleFont: {
      ...HEADING_FONT,
      color: "#ffffff",
      fontSize: isMobile ? "18px" : isTablet ? "30px" : "40px",
    },
    sectionTop: {
      backgroundImage: "url(back-img-top.png)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      padding: isMobile ? "20px 30px 150px" : isTablet ? "40px 60px 150px" : "50px 200px 200px",
    },
    heading1: {
      ...HEADING_FONT,
      fontSize: isMobile ? "35px" : isDesktop ? "110px" : isFlex ? "80px" : "50px",
      margin: "20px auto 50px",
      color: THEME_COLOR,
      textShadow: "5px 5px 0 #000000",
    },
    section: {
      padding: isMobile ? "50px 20px" : isTablet ? "50px" : "100px 200px 50px",
    },
    heading2: HEADING_FONT,
    step: {
      fontSize: isMobile ? "20px" : "30px",
      marginBottom: "15px",
    },
    stepImage: {
      width: isMobile ? "150px" : "200px",
      height: isMobile ? "150px" : "200px",
      borderRadius: "50%",
    },
    paragraph: {
      fontSize: isMobile ? "14px" : "20px",
    },
    buttonLink: {
      color: "#000000",
      textDecoration: "none",
    },
  };

  return (
    <div style={styles.container}>
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@700&display=swap"
        rel="stylesheet"
      ></link>
      {!isProduction && (
        <div>
          <Link to="/">コンテンツ画面を表示</Link>
        </div>
      )}
      <section style={styles.sectionTop}>
        <div style={styles.title}>
          <img src="icon.png" alt="App Icon" style={styles.titleImage} />
          <span style={styles.titleFont}>キントレマニア</span>
        </div>
        <div>
          <h1 style={styles.heading1}>
            調べる時間を
            <br />
            筋トレの時間に
          </h1>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button variant="warning" size="lg">
            <Link to="/" style={styles.buttonLink}>
              サービスを利用する
            </Link>
          </Button>
        </div>
      </section>
      <section style={styles.section}>
        <h2 style={styles.heading2}>{APP_NAME}とは？</h2>
        <div
          style={{
            display: "flex",
            flexDirection: isFlex ? "row" : "column",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "30px",
          }}
        >
          <div style={{ fontSize: isMobile ? "16px" : "20px" }}>
            <p>"伝統的な王道種目こそ最高の筋トレ"と考えている筋トレマニアが</p>
            <p>「筋トレの良動画をまとめておきたい！」と思って開発した</p>
            <p>YouTube動画のまとめサービスです</p>
          </div>
          <div style={isFlex ? { marginLeft: "20px" } : {}}>
            <img
              src="back-img-middle.png"
              alt="Middle Image"
              style={{ maxWidth: isMobile ? "250px" : "400px", height: "auto" }}
            />
          </div>
        </div>
      </section>
      <section style={styles.section}>
        <h2 style={styles.heading2}>{APP_NAME}の使い方</h2>
        <div
          style={{
            display: "flex",
            flexDirection: isFlex ? "row" : "column",
            justifyContent: "space-around",
            alignItems: "center",
            textAlign: "center",
            margin: "30px auto",
          }}
        >
          {["カテゴリで絞る", "動画を見る", "実践"].map((text, index) => (
            <div key={index} style={!isFlex && index !== 2 ? { marginBottom: "20px" } : {}}>
              <div style={styles.step}>
                <div>STEP{index + 1}</div>
                <div>{text}</div>
              </div>
              <div>
                <img
                  src={`step${index + 1}.png`}
                  alt={`Step ${index + 1}`}
                  style={styles.stepImage}
                />
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", fontSize: isMobile ? "14px" : "20px" }}>
          <p>検索の手間を省けるように、目的・部位でカテゴリを分けています</p>
          <p>
            ロジックに基づいた筋トレ動画を速攻で見つけて効果的なトレーニングに役立ててください！
          </p>
        </div>
      </section>
      <section
        style={{
          ...styles.section,
          backgroundImage: "url(back-img-bottom.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h2 style={styles.heading2}>{APP_NAME}の活用法</h2>
        <h3 style={{ marginTop: "30px" }}>全身をバランス良く鍛えるメニューの参考に</h3>
        <p style={styles.paragraph}>
          このアプリでは、「上半身」「下半身」「体幹」「有酸素運動」「体のケア」というメインカテゴリで動画を整理しています。
        </p>
        <p style={styles.paragraph}>
          また、上半身と下半身に分けて筋トレメニューを組む2分割法をはじめ、様々な分割法に対応できるように、メインカテゴリを細かく分類したサブカテゴリ（例：「デッドリフト系」「スクワット系」等）も用意しているので、メニュー作りの参考にしてください！
        </p>
        <h3 style={{ marginTop: "30px" }}>やる気が出ない人でも筋トレを始められる</h3>
        <p style={styles.paragraph}>「何をやれば良いかわからない」「筋トレの方法がわからない」</p>
        <p style={styles.paragraph}>
          そんな筋トレのやる気を低下させる不安を解消できるように、基本的かつ伝統的なトレーニングの動画や、エラーフォームと正しいフォームの知識を学べる動画をピックアップしています。
        </p>
        <p style={styles.paragraph}>
          また、初心者アイコンがついた動画から見ることで、筋トレに慣れていない方もすぐに筋トレを実践できます！
        </p>
        <h3 style={{ marginTop: "30px" }}>安全は筋トレを継続する</h3>
        <p style={styles.paragraph}>
          「腹圧の高め方」「呼吸のリズム」等、少しマニアックな動画もピックアップしています。
        </p>
        <p style={styles.paragraph}>
          「やった感」を感じることよりも、効果的かつ安全なトレーニングが続けられることを重視しているので、ぜひチェックしてみてください！
        </p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button variant="warning" size="lg">
            <Link to="/" style={styles.buttonLink}>
              サービスを利用する
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default LP;
